import { cn } from "@/lib/utils";

type Props = {
  /** 0..1 o 0..100 si pasas `max`. */
  value: number;
  /** Default 1. Si pasas 100, value se interpreta como porcentaje 0..100. */
  max?: number;
  /** Variante visual — afecta el color del fill. */
  variant?: "default" | "success" | "warning" | "destructive";
  /** Tamaño del bar. `sm` para listas inline, `md` para drawers/modales. */
  size?: "xs" | "sm" | "md";
  className?: string;
  /** Si true, muestra animación shimmer en el fill (para indicar actividad). */
  pulse?: boolean;
};

const VARIANT_BG: Record<NonNullable<Props["variant"]>, string> = {
  default: "bg-gradient-to-r from-primary to-electric",  // rc146.1 Glass Zafiro
  success: "bg-emerald-500",
  warning: "bg-amber-500",
  destructive: "bg-destructive",
};

const SIZE_H: Record<NonNullable<Props["size"]>, string> = {
  xs: "h-1",
  sm: "h-1.5",
  md: "h-2.5",
};

/**
 * dev119 — Barra de progreso simple. Usada en jobs MikroTik para mostrar
 * cuántos contratos llevan procesados de cuántos.
 */
export function ProgressBar({
  value,
  max = 1,
  variant = "default",
  size = "sm",
  className,
  pulse = false,
}: Props) {
  const pct = Math.max(0, Math.min(100, (value / Math.max(0.0001, max)) * 100));
  return (
    <div
      className={cn(
        "w-full overflow-hidden rounded-full bg-muted",
        SIZE_H[size],
        className,
      )}
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className={cn(
          "h-full transition-[width] duration-300 ease-out",
          VARIANT_BG[variant],
          pulse && "animate-pulse",
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
